export default __webpack_public_path__ + "static/media/3730_124802.3224d552.svg";